import { Browsers } from '@shared/enums/browsers';

export const isSafari =
  navigator.userAgent.indexOf(Browsers.Safari) > -1 && navigator.userAgent.indexOf(Browsers.Chrome) <= -1;
export const isFirefox =
  navigator.userAgent.indexOf(Browsers.Firefox) > -1 && navigator.userAgent.indexOf(Browsers.Chrome) <= -1;
